import React, { useEffect } from "react";
import { formatCountDownTime, isDaysRemaining } from "../../../utils/time";
import { useTimerContext } from "../../../utils/contexts/TimerContext";
import { Timer } from "@carbon/icons-react";
import { formatSimpleDate } from "../../../utils/date";

interface TimerSectionProps {
  backgroundColour?: string;
  textColour?: string;
  rightIcon?: React.ReactNode;
  setIsTimerCompleted?: React.Dispatch<React.SetStateAction<boolean>>;
  startDate?: string;
}

export const TimerSection = ({
  backgroundColour,
  textColour,
  rightIcon,
  setIsTimerCompleted,
  startDate,
}: TimerSectionProps) => {
  const { timeLeft } = useTimerContext();
  const isLessThanOneMinute = timeLeft <= 60;
  const safeTimeLeft = Math.max(timeLeft, 0);

  const formatedTime =
    startDate && isDaysRemaining(safeTimeLeft)
      ? formatSimpleDate(startDate)
      : formatCountDownTime(safeTimeLeft);

  useEffect(() => {
    if (timeLeft === 0 && setIsTimerCompleted) {
      setIsTimerCompleted(true);
    }
  }, [timeLeft, setIsTimerCompleted]);

  return (
    <div
      className={`flex items-center space-x-2 ${backgroundColour ? backgroundColour : "bg-yellow-300"} py-2 px-3 rounded-full`}>
      {!rightIcon && (
        <Timer
          size={20}
          className={`text-2xl ${isLessThanOneMinute ? "text-red-600" : textColour ? textColour : "text-orange-700"}`}
        />
      )}
      <p
        className={`text-base font-normal text-center font-mono ${
          isLessThanOneMinute ? "text-red-600" : textColour ? textColour : "text-orange-700"
        }`}>
        {formatedTime}
      </p>
      {rightIcon && rightIcon}
    </div>
  );
};
